// extracted by mini-css-extract-plugin
export var contact = "contact-module--contact--efa9q";
export var center = "contact-module--center--XizxR";
export var formControl = "contact-module--formControl--ka9uH";
export var submit = "contact-module--submit---AHiT";